const products = [
    {
        "name": "Máy trải vải X5",
        "description": "Máy trải vải series Xiaomai X5 sử dụng công nghệ tiên tiến, cung cấp nhiều mẫu mã đáp ứng các yêu cầu khác nhau. Với chiều rộng trải từ 1600mm đến 3100mm và trọng lượng vải tối đa 110kg, chúng đảm bảo hiệu suất ổn định và hiệu quả. Các máy này được sử dụng rộng rãi trong các ứng dụng công nghiệp và là lựa chọn lý tưởng trong lĩnh vực dệt.",
        "imageUrl": "/files/images/product1.png",
        route:'x5'
    },
    {
        "name": "Máy trải vải X6",
        "description": "Máy trải vải series Xiaomai X6 được yêu thích trong ngành dệt nhờ hiệu suất ổn định và hiệu quả cao. Chúng cung cấp chiều rộng trải từ 1600mm đến 3100mm và trọng lượng vải tối đa 110kg, duy trì tốc độ vận hành tối đa 85-88m/phút để đáp ứng nhu cầu sản xuất cao.",
        "imageUrl": "/files/images/product2.png",
        route:'x6'
    },
    {
        "name": "Máy Mẹ-Con",
        "description": "Được thiết kế để xử lý các loại vải phức tạp hơn, máy Mẹ-Con có thể xử lý nhiều loại vải cùng lúc, khác với series X5 và X6. Nó phù hợp với vải nhiều lớp và vật liệu đặc biệt, mang lại lợi thế đáng kể khi đối mặt với yêu cầu vải phức tạp và đa dạng.",
        "imageUrl": "/files/images/product3.png",
        route:'zm'
    }
];

export default products;
